import React from 'react';
import { NumberInput } from 'components/Input';

interface Props {
  value: string;
  onChange: (value: string | number) => void;
}

export default (props: Props) => {
  const { value, onChange } = props;
  return (
    <NumberInput
      value={value}
      onChange={(newValue) => onChange(newValue || '')}
      width="100%"
      height="26px"
      border="none"
      fontSize="12px"
    />
  );
};
